export default "__VITE_ASSET__5MHckxff__"